import React, { useEffect } from 'react';
import { parseEntities } from 'parse-entities';

import { ValidationMessage } from './ValidationMessage';
import { Validation } from '../helpers/validation-helper';

export interface Props {
  id: string;
  placeHolder: string;
  type: string;
  validation?: Validation;
  onChange: (value: string) => void;
  disabled?: boolean;
  contactFormRole?: string;
  defaultValue?: string;
}

export const InputField = ({
  id,
  placeHolder,
  type,
  validation,
  onChange,
  disabled,
  contactFormRole,
  defaultValue = '',
}: Props) => {
  const errorClassName = validation && !validation.isValid ? 'error' : '';
  const [focused, setFocused] = React.useState(false);
  const [dataShrink, setShrink] = React.useState(false);
  const [inputValue, getInputValue] = React.useState(defaultValue);
  // eslint-disable-next-line no-sequences
  const onFocus = () => (setFocused(true), setShrink(true));
  const onBlur = () => {
    setFocused(false);
    setShrink(!!inputValue.trim());
  };
  const onFieldChange = (e: any) => {
    getInputValue(e.target.value);
    onChange(e.target.value);
  };

  useEffect(() => {
    getInputValue(defaultValue);
  }, [defaultValue]);

  const labelAutoFill = inputValue.length > 0;

  return (
    <>
      <div className={`main-text-field ${disabled ? 'disabled' : ''} ${errorClassName}`}>
        <label
          className={`main-text-field-label body-3 ${focused ? 'focused' : ''} ${
            dataShrink || labelAutoFill ? 'shrink' : ''
          } ${errorClassName}`}
          htmlFor={type}
          id={`${type}-${id}-label`}
        >
          {parseEntities(placeHolder)}
        </label>
        <div className={`text-input-field ${focused ? 'focused' : ''} ${errorClassName}`}>
          {type !== 'textarea' ? (
            <input
              type={type}
              id={id}
              className="main-text-field-input body-3"
              aria-invalid="false"
              aria-label={type}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={onFieldChange}
              value={inputValue}
              disabled={disabled}
              // eslint-disable-next-line react/no-unknown-property
              contact-form-role={contactFormRole}
            />
          ) : (
            <textarea
              id={id}
              className="main-text-field-input body-3"
              // eslint-disable-next-line react/no-unknown-property
              contact-form-role={contactFormRole}
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={onFieldChange}
              value={inputValue}
              disabled={disabled}
              aria-label="Your message"
            />
          )}
          <fieldset aria-hidden="true" className="main-text-field-fieldset">
            <legend className="main-text-field-legend">
              <span>{parseEntities(placeHolder)}</span>
            </legend>
          </fieldset>
        </div>
      </div>
      {validation && !validation.isValid && <ValidationMessage text={validation.validationMessage} />}
    </>
  );
};
